<script setup lang="ts">
import { provide, reactive, computed } from 'vue';
import { ConfigProvider, theme } from 'ant-design-vue';
import dayjs from 'dayjs';
import enUS from 'ant-design-vue/es/locale/en_US';

import useConfig from '@/providers/config/useConfig';
import { ThemeOpts } from '@/providers/config/theme';
import type { DateFormatProps} from '@/config/local/en';
import { dateFormatEn, USE_LOCALPROVIDER } from '@/config/local/en';

dayjs.locale(enUS.locale);
provide(USE_LOCALPROVIDER, reactive<DateFormatProps>(dateFormatEn));
const config = useConfig();

const antdTheme = computed(() => (config.config.name === ThemeOpts.light
  ? theme.defaultAlgorithm
  : theme.darkAlgorithm));
</script>

<template>
  <ConfigProvider
    :locale="enUS"
    :theme="{ algorithm: antdTheme }"
  >
    <slot />
  </ConfigProvider>
</template>
